import style from "./styles/TotalExpensesCard.module.css";
import React from "react";

const MiddleStatistic = ({summ, period}) => {
    return (
        <div className={style.cardFooter}>
            <div className={style.details}>
                <div className={style.detailItem}>
                    <span className={style.detailLabel}>Среднемесячно:</span>
                    <span className={style.detailValue}>
                            {summ}
                        </span>
                </div>
                <div className={style.detailItem}>
                    <span className={style.detailLabel}>Период:</span>
                    <span className={style.detailValue}>
                            {period} мес.
                        </span>
                </div>
            </div>
        </div>
    )
}

export default MiddleStatistic;